import React from 'react';
import Main from './Main';
import Authorize from './Authorize';
import { AppProvider } from './AppContext';
import TranslateProvider from './TranslateProvider';

const enableAuth = window.AUTH_CONTEXT.enabled;
const authRedirectUrl = window.AUTH_CONTEXT.redirectUrl;

const App = () => (
  <AppProvider>
    <TranslateProvider>
      <Authorize enabled={enableAuth} authRedirectUrl={authRedirectUrl}>
        <Main />
      </Authorize>
    </TranslateProvider>
  </AppProvider>
);

export default App;
